import AppLayout from '@/layout/AppLayout.vue';
import { callAPI, DRUPAL_API_ROUTE } from '../service/DrupalService';
import { createRouter, createWebHistory } from 'vue-router';

const homepage = import.meta.env.VITE_DRUPAL_URL;

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('@/views/Dashboard.vue')
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import('@/views/Dashboard.vue')
                },
                {
                    path: '/shortlinks',
                    name: 'shortlinks',
                    component: () => import('@/views/ShortLinks.vue')
                },
                {
                    path: '/pages',
                    name: 'pages',
                    component: () => import('@/views/Pages.vue')
                },
                {
                    path: '/webforms',
                    name: 'webforms',
                    component: () => import('@/views/Webforms.vue')
                },
                {
                    path: '/domains',
                    name: 'domains',
                    component: () => import('@/views/Domains.vue')
                },
                {
                    path: '/workspaces',
                    name: 'workspaces',
                    component: () => import('@/views/Workspaces.vue')
                },
                {
                    path: '/scheduled',
                    name: 'scheduled',
                    component: () => import('@/views/Scheduled.vue')
                }
            ]
        }
    ]
});

router.beforeEach(async (routeTo, routeFrom, next) => {
    var user = await callAPI(DRUPAL_API_ROUTE.USER);

    if (!user || user.status != 200) {
        window.location.href = homepage + '/user/login?auth_error=1';
        return next(false);
    }

    if (routeFrom.path == '/' && !routeFrom.name) {
        var workspaces = await callAPI(DRUPAL_API_ROUTE.WORKSPACES);
        localStorage.setItem('workspaces', JSON.stringify(workspaces.data));

        var currentWorkspaceData = workspaces.data.find((item) => item.id === user.data.current_workspace);
        user.data.role = currentWorkspaceData.role;
        user.data.permissions = currentWorkspaceData.permissions;
        user.data.plan = currentWorkspaceData.plan;

        var shortlinksDomains = await callAPI(DRUPAL_API_ROUTE.WORKSPACES_DOMAINS_LIST, { workspace: user.data.current_workspace, type: 'shortlinks' });
        localStorage.setItem('shortlinksDomains', JSON.stringify(shortlinksDomains.data));


        var webformsDomains = await callAPI(DRUPAL_API_ROUTE.WORKSPACES_DOMAINS_LIST, { workspace: user.data.current_workspace, type: 'webforms' });
        localStorage.setItem('webformsDomains', JSON.stringify(webformsDomains.data));
    } else {
        var currentUserData = JSON.parse(localStorage.getItem('user'));
        user.data.role = currentUserData.role;
        user.data.permissions = currentUserData.permissions;
        user.data.plan = currentUserData.plan;
    }
    localStorage.setItem('user', JSON.stringify(user.data));

    next();
});

router.onError((error, to) => {
    const isChunkLoadError =
        error?.message?.includes('Failed to fetch dynamically imported module') ||
        error?.message?.includes('Importing a module script failed') ||
        error?.name === 'ChunkLoadError';

    if (isChunkLoadError) {
        window.location.href = to.fullPath;
    }
});

export default router;
